<template>
  <div>
    <div id="registrationDelete_alert" class="modal fade custom" role="dialog">
      <div class="modal-dialog modal-md custom-reg-delete-modal-class">
        <!-- Modal content-->
        <div class="modal-content">
          <div class="modal-header font-weight-600" style="font-weight: 600; padding-bottom: 0px;">
            <img src="/static/images/icons/close_x.svg" class="icon-close" @click="closeRegistrationAlertModal" />
          </div>
          <div class="modal-body exceed-modal-body" style="padding: 0px;padding-bottom: 10px;padding-top: 0px;">
            <div class="container-fluid">
              <div class="col-md-12 max-limit-exceeded p-15">
                {{ $t('maxLimitExceeded') }}
              </div>
              <div class="col-md-12 delete-more-files p-15">
                {{ $t('tryingToDelete') }} {{ max_records_delete }} {{ $t('recordsAtaTime') }}.
                {{ $t('pleaseSelect') }} {{ max_records_delete }} {{ $t('recordsLessTryAgain') }}.
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn exceed-close-btn no-cancel-button" data-dismiss="modal">
              {{ $t('close') }}
            </button>
          </div>
        </div>
      </div>
    </div>
    <div id="registrationDelete" class="modal fade" role="dialog">
      <div class="modal-dialog modal-md delete-popup">
        <!-- Modal content-->
        <div class="modal-content w-500">
          <div class="modal-header">
            <section>
              <div class="col-xs-12 p-16 d-flex align-items-center justify-content-between header-wrapper">
                <div class="modal-header-title fw-600 font-20">{{$t('deleteCertificates')}}</div>
                <img
                  class="pr-5 cursor-pointer"
                  src="/static/images/icons/emergo_modal_close.svg"
                  @click="closeModal"
                />
              </div>
            </section>
          </div>
          <div class="modal-body p-0">
            <div class="col-xs-12 pl-20 pr-20 mb-16 font-18 fw-400 delete-confirm-text">
              <span
                v-if="this.validateSFManagedReecordFlag && (roleId === 8 || roleId === 9)"
                style="color: #a94442 !important;"
              >
                Records indicated in red are Emergo managed and cannot be deleted.
                <br />
              </span>
              {{ $t('yourAreAboutToDeleteTheRecord') }}(s). {{ $t('onceDeleted') }}, {{ $t('youWillNotBeAbleToRecoverIt') }}.
            </div>
            <div class="col-xs-12 warning-text pl-20 mb-30 pr-20 delete-confirm-text fw-600 font-16">
              {{ $t('DoYouStillWantToProceed') }}?
            </div>
          </div>
          <div class="modal-footer p-16" style="clear: both;">
            <section>
              <div class="col-xs-12 p-0 d-flex justify-content-end col-gap-16">
                <button
                  type="button"
                  class="btn emergo-btn emergo-secondary-button"
                  data-dismiss="modal"
                  @click="cancelDelete"
                >
                  {{ $t('noCancel') }}
                </button>

                <button
                  type="button"
                  class="btn emergo-btn emergo-primary-button"
                  @click="deleteRegistrations"
                  :disabled="loaderStatus"
                >
                {{ $t('yesProceed') }}
                  <!-- {{ $t('Yes') }}, {{ $t('delete') }} -->
                </button>
              </div>
            </section>
          </div>
        </div>
        <loader :loadingStatus="loaderStatus"></loader>
      </div>
    </div>
  </div>
</template>

<script>
import $ from 'jquery';
import Loader from '../UIComponents/Loader.vue';
import { deleteMultiRegistrationDetails } from '../../apis/registrations';
import { deleteRecord } from '../../apis/BulkUpload';

export default {
  components: {
    Loader
  },
  props: {
    data: Array,
    roleId: Number,
    max_records_delete: Number,
    recordType: String,
  },
  data() {
    return {
      loaderStatus: false,
      errors: [],
      validateSFManagedReecordFlag: false
    };
  },
  methods: {
    closeModal() {
      $('#registrationDelete').modal('hide');
    },
    closeRegistrationAlertModal() {
      $('#registrationDelete_alert').modal('hide');
    },
    clearNotifcations() {
      this.$notify({
        clear: true,
        group: 'custom-notification'
      });
    },

    cancelDelete() {
      this.validateSFManagedReecordFlag = false;
      this.$emit('loadRegistrationDataAfterCancel', this.data);
    },
    validateSFManagedReecords(index) {
      if (this.data[index].salesForceManaged !== 'no' && (this.roleId === 8 || this.roleId === 9)) {
        this.validateSFManagedReecordFlag = true;
        return 'highlighted-row-error';
      }
      return '';
    },
    async deleteRegistrations() {
      this.loaderStatus = true;
      const records = {};
      records.registrationId = [];
      this.data.forEach((row) => {
        if (this.roleId === 8 || this.roleId === 9) {
          if (row.salesForceManaged === 'no') {
            records.registrationId.push(row.registrationId);
          }
        } else {
          records.registrationId.push(row.registrationId);
        }
      });

      if (records.length === 0) {
        this.clearNotifcations();
        this.$notify({
          type: 'error',
          title: this.$i18n.locale === 'Portuguese' ? 'Erro' : 'Error',
          text: 'No record deleted!',
          group: 'custom-notification'
        });
        this.loaderStatus = false;
        $('#registrationDelete').modal('hide');
        this.validateSFManagedReecordFlag = false;
        return;
      }
      if (this.recordType === 'Invalid Records') {
        this.deleteInvalidRecord(records);
        return;
      }
      const response = await deleteMultiRegistrationDetails(records);
      this.loaderStatus = false;
      if (response.status_code === 200) {
        this.clearNotifcations();
        this.$notify({
          type: 'success',
          title: this.$i18n.locale === 'Portuguese' ? 'Sucesso' : 'Success',
          text:
            this.$i18n.locale === 'Portuguese'
              ? 'Certificados(s) excluído(s) com sucesso!'
              : 'Certificates(s) deleted successfully!',
          group: 'custom-notification'
        });
        $('#registrationDelete').modal('hide');
        this.validateSFManagedReecordFlag = false;
        this.$emit('loadRegistrationDataAfterDelete', records);
      } else {
        this.clearNotifcations();
        this.$notify({
          type: 'error',
          title: this.$i18n.locale === 'Portuguese' ? 'Erro' : 'Error',
          text:
            this.$i18n.locale === 'Portuguese'
              ? 'Não foi possível excluir o(s) registro(s)!'
              : 'Unable to delete registration(s)!',
          group: 'custom-notification'
        });
      }
    },
    async deleteInvalidRecord(records) {
      const response = await deleteRecord(records);
      this.loaderStatus = false;
      if (response.status === 204) {
        this.clearNotifcations();
        this.$notify({
          type: 'success',
          title: this.$i18n.locale === 'Portuguese' ? 'Sucesso' : 'Success',
          text:
            this.$i18n.locale === 'Portuguese'
              ? 'Registro excluído.'
              : 'Record(s) deleted.',
          group: 'custom-notification'
        });
        $('#registrationDelete').modal('hide');
        this.$emit('loadInvalidRecords');
      } else {
        this.clearNotifcations();
        this.$notify({
          type: 'error',
          title: this.$i18n.locale === 'Portuguese' ? 'Erro' : 'Error',
          text:
            this.$i18n.locale === 'Portuguese'
              ? 'Não foi possível excluir registros'
              : 'Unable to delete record(s)',
          group: 'custom-notification'
        });
      }
    }
  }
};
</script>
<style scoped>
.container-fluid {
  text-align: center;
}
.delete-record {
  font-size: 24px;
  font-weight: 300;
  color: #333333;
  padding-bottom: 10px;
}
.delete-more-files {
  color: #333333;
  font-weight: 300;
  font-size: 18px;
}
.once-deleted {
  font-size: 16px;
  color: #333333;
  font-weight: 300;
}
.max-limit-exceeded {
  font-weight: 700;
  font-size: 18px;
  color: #333333;
}
.still-proceed {
  font-weight: 700;
  font-size: 18px;
  color: #333333;
  padding-top: 24px;
}
.custom-reg-delete-modal-class {
  margin-top: 3%;
  width: 600px !important;
}
.modal-content {
  height: 250px;
  box-shadow: 4px 4px 10px rgba(0, 0, 0, 0.25);
}
.icon-close {
  color: #333333 !important;
  float: right;
  cursor: pointer;
}
.custom-reg-delete-modal-class .modal-header {
  background-color: #ffffff;
  border-bottom: none;
  border-radius: 5px;
}
.custom-reg-delete-modal-class .modal-footer {
  background-color: #ffffff;
  border-top: none;
  position: absolute;
  bottom: 0%;
  width: 100%;
  padding-bottom: 24px;
  border-radius: 5px;
}
.yes-save-changes,
.yes-save-changes:hover {
  padding: 10px 53px 9px 53px;
}
.table > tbody > tr > td {
  padding-left: 7px !important;
}
.exceed-close-btn {
  background: #fff;
  float: right;
}
.exceed-modal-body {
  padding: 0px;
  padding-bottom: 10px;
  padding-top: 20px;
}
.font-weight-600 {
  font-weight: 600;
}

.header-wrapper {
  border-bottom: 1px solid #d3d3d3;
  margin-bottom: 16px;
}

#registrationDelete .modal-header {
  padding: 0px;
}

.delete-confirm-text {
  line-height: 25px;
  color: #333333;
}

.delete-popup .modal-header,
.delete-popup .modal-footer {
  background: #ffffff;
  border-bottom: none;
  border-radius: 8px;
  color: #1a1a1a;
}

.delete-popup .modal-footer {
  border-top: none;
  background: #fafaf9;
}

.delete-popup .modal-footer .btn + .btn {
  margin-left: 0px;
}

.delete-popup .modal-content {
  height: unset;
}

.modal-header-title {
  line-height: 27px;
  color: #1a1a1a;
}

.warning-text {
  margin-bottom: 66px;
}

@media screen and (min-width: 768px) {
  .modal-dialog {
    width: 500px;
  }

  .w-500 {
    width: 500px;
  }
}
</style>
